import React from 'react';
import { SliderGallery, SliderImage } from './SliderGallery';

// Real estate images extracted from the HTML code
const sampleImages: SliderImage[] = [
  {
    id: 1,
    src: '//openapi.images.anywhere.re/1FC5B80D-B2C8-42E3-A5E6-25688BC7B389',
    thumbnail: '//openapi.images.anywhere.re/1FC5B80D-B2C8-42E3-A5E6-25688BC7B389',
    alt: 'Luxury home exterior',
    caption: 'Beautiful modern home with elegant architecture'
  },
  {
    id: 2,
    src: '//openapi.images.anywhere.re/1B229CB6-2AFE-4B3B-AC52-EF7E30176F61',
    thumbnail: '//openapi.images.anywhere.re/1B229CB6-2AFE-4B3B-AC52-EF7E30176F61',
    alt: 'Spacious living room',
    caption: 'Open concept living area with natural light'
  },
  {
    id: 3,
    src: '//openapi.images.anywhere.re/AB3E03C2-6153-48BD-B100-0B7127DB3648',
    thumbnail: '//openapi.images.anywhere.re/AB3E03C2-6153-48BD-B100-0B7127DB3648',
    alt: 'Modern kitchen',
    caption: 'Gourmet kitchen with premium appliances'
  },
  {
    id: 4,
    src: '//openapi.images.anywhere.re/81DBE032-E5AD-4A6C-857E-59D31FE27642',
    thumbnail: '//openapi.images.anywhere.re/81DBE032-E5AD-4A6C-857E-59D31FE27642',
    alt: 'Master bedroom',
    caption: 'Elegant master suite with ensuite bathroom'
  },
  {
    id: 5,
    src: '//openapi.images.anywhere.re/3648F3EF-3B97-4FA9-AE12-85651162EEAD',
    thumbnail: '//openapi.images.anywhere.re/3648F3EF-3B97-4FA9-AE12-85651162EEAD',
    alt: 'Outdoor patio',
    caption: 'Private outdoor living space with landscaping'
  },
  {
    id: 6,
    src: '//openapi.images.anywhere.re/46C65EE8-4709-4A3E-8268-0F5B72470EC0',
    thumbnail: '//openapi.images.anywhere.re/46C65EE8-4709-4A3E-8268-0F5B72470EC0',
    alt: 'Home office',
    caption: 'Dedicated workspace with built-in storage'
  },
  {
    id: 7,
    src: '//openapi.images.anywhere.re/2FE53F10-1B3D-4807-A099-DDDA8043CCC3',
    thumbnail: '//openapi.images.anywhere.re/2FE53F10-1B3D-4807-A099-DDDA8043CCC3',
    alt: 'Dining area',
    caption: 'Formal dining room with elegant fixtures'
  },
  {
    id: 8,
    src: '//openapi.images.anywhere.re/D7C71090-F2E1-40E6-9DF4-DAE34725EA71',
    thumbnail: '//openapi.images.anywhere.re/D7C71090-F2E1-40E6-9DF4-DAE34725EA71',
    alt: 'Bathroom',
    caption: 'Luxurious bathroom with modern amenities'
  },
  {
    id: 9,
    src: '//openapi.images.anywhere.re/37416F8A-51E1-4FE6-8FA6-17258D181410',
    thumbnail: '//openapi.images.anywhere.re/37416F8A-51E1-4FE6-8FA6-17258D181410',
    alt: 'Garage',
    caption: 'Attached garage with ample storage space'
  },
  {
    id: 10,
    src: '//openapi.images.anywhere.re/FC187F63-8108-40C5-AA55-87FEE67FDCBA',
    thumbnail: '//openapi.images.anywhere.re/FC187F63-8108-40C5-AA55-87FEE67FDCBA',
    alt: 'Backyard view',
    caption: 'Expansive backyard with mature landscaping'
  },
  {
    id: 11,
    src: '//openapi.images.anywhere.re/2F1F26EB-2BC4-4E10-9293-9E35B5E77BFB',
    thumbnail: '//openapi.images.anywhere.re/2F1F26EB-2BC4-4E10-9293-9E35B5E77BFB',
    alt: 'Family room',
    caption: 'Cozy family room with fireplace'
  },
  {
    id: 12,
    src: '//openapi.images.anywhere.re/7E593719-6A2A-4633-B1BE-FDABF0176A04',
    thumbnail: '//openapi.images.anywhere.re/7E593719-6A2A-4633-B1BE-FDABF0176A04',
    alt: 'Guest bedroom',
    caption: 'Comfortable guest bedroom with ensuite'
  },
  {
    id: 13,
    src: '//openapi.images.anywhere.re/581FE088-EE2B-43F0-AB24-B035B02453DC',
    thumbnail: '//openapi.images.anywhere.re/581FE088-EE2B-43F0-AB24-B035B02453DC',
    alt: 'Laundry room',
    caption: 'Convenient laundry room with storage'
  },
  {
    id: 14,
    src: '//openapi.images.anywhere.re/46DDD5FB-7F40-420A-8C49-C3C42302DFD9',
    thumbnail: '//openapi.images.anywhere.re/46DDD5FB-7F40-420A-8C49-C3C42302DFD9',
    alt: 'Wine cellar',
    caption: 'Temperature-controlled wine storage'
  },
  {
    id: 15,
    src: '//openapi.images.anywhere.re/6D6DE407-696C-4C7A-BBB7-3BC1341852E7',
    thumbnail: '//openapi.images.anywhere.re/6D6DE407-696C-4C7A-BBB7-3BC1341852E7',
    alt: 'Home theater',
    caption: 'Private home theater with premium sound'
  },
  {
    id: 16,
    src: '//openapi.images.anywhere.re/74C0DA2D-BD03-4A56-87AA-0E632DD4BC5B',
    thumbnail: '//openapi.images.anywhere.re/74C0DA2D-BD03-4A56-87AA-0E632DD4BC5B',
    alt: 'Gym',
    caption: 'Private fitness room with equipment'
  },
  {
    id: 17,
    src: '//openapi.images.anywhere.re/7728448D-EE79-49B8-8E17-A118B8978B65',
    thumbnail: '//openapi.images.anywhere.re/7728448D-EE79-49B8-8E17-A118B8978B65',
    alt: 'Pool area',
    caption: 'Resort-style pool with outdoor kitchen'
  },
  {
    id: 18,
    src: '//openapi.images.anywhere.re/276F8846-DD28-4231-BBEA-DEC43DB54579',
    thumbnail: '//openapi.images.anywhere.re/276F8846-DD28-4231-BBEA-DEC43DB54579',
    alt: 'Walk-in closet',
    caption: 'Spacious walk-in closet with organization'
  },
  {
    id: 19,
    src: '//openapi.images.anywhere.re/5218C4CA-1FB9-431B-9CFC-57089B4AF31A',
    thumbnail: '//openapi.images.anywhere.re/5218C4CA-1FB9-431B-9CFC-57089B4AF31A',
    alt: 'Study room',
    caption: 'Quiet study with built-in bookshelves'
  },
  {
    id: 20,
    src: '//openapi.images.anywhere.re/2738AA78-24BB-44BF-85D2-2A040E33BA1A',
    thumbnail: '//openapi.images.anywhere.re/2738AA78-24BB-44BF-85D2-2A040E33BA1A',
    alt: 'Mudroom',
    caption: 'Organized mudroom with storage solutions'
  },
  {
    id: 21,
    src: '//openapi.images.anywhere.re/4A6A7D7F-0319-49D5-B8A8-809FEBEC0A8F',
    thumbnail: '//openapi.images.anywhere.re/4A6A7D7F-0319-49D5-B8A8-809FEBEC0A8F',
    alt: 'Breakfast nook',
    caption: 'Cozy breakfast area with natural light'
  },
  {
    id: 22,
    src: '//openapi.images.anywhere.re/B55734E4-6107-4313-B039-67CD382AE67E',
    thumbnail: '//openapi.images.anywhere.re/B55734E4-6107-4313-B039-67CD382AE67E',
    alt: 'Powder room',
    caption: 'Elegant powder room with modern fixtures'
  },
  {
    id: 23,
    src: '//openapi.images.anywhere.re/DFC36462-0D13-4302-BAE3-6ED79987C0D5',
    thumbnail: '//openapi.images.anywhere.re/DFC36462-0D13-4302-BAE3-6ED79987C0D5',
    alt: 'Game room',
    caption: 'Entertainment space with gaming setup'
  },
  {
    id: 24,
    src: '//openapi.images.anywhere.re/BAD06886-7183-47A1-96C2-F366CFD51EDB',
    thumbnail: '//openapi.images.anywhere.re/BAD06886-7183-47A1-96C2-F366CFD51EDB',
    alt: 'Library',
    caption: 'Home library with custom shelving'
  },
  {
    id: 25,
    src: '//openapi.images.anywhere.re/5B6C3545-B1C6-4818-AEBD-B6E43C279364',
    thumbnail: '//openapi.images.anywhere.re/5B6C3545-B1C6-4818-AEBD-B6E43C279364',
    alt: 'Sunroom',
    caption: 'Bright sunroom with panoramic views'
  },
  {
    id: 26,
    src: '//openapi.images.anywhere.re/E456B3B3-1FEE-4C31-8642-211CEB5EB3D8',
    thumbnail: '//openapi.images.anywhere.re/E456B3B3-1FEE-4C31-8642-211CEB5EB3D8',
    alt: 'Butler pantry',
    caption: 'Convenient butler pantry for entertaining'
  },
  {
    id: 27,
    src: '//openapi.images.anywhere.re/E6990210-264D-49B0-A2DB-C4BD3242E90D',
    thumbnail: '//openapi.images.anywhere.re/E6990210-264D-49B0-A2DB-C4BD3242E90D',
    alt: 'Media room',
    caption: 'Professional media room with sound system'
  },
  {
    id: 28,
    src: '//openapi.images.anywhere.re/F550D8CF-5EC1-4BA5-A96D-07745813B28B',
    thumbnail: '//openapi.images.anywhere.re/F550D8CF-5EC1-4BA5-A96D-07745813B28B',
    alt: 'Outdoor kitchen',
    caption: 'Full outdoor kitchen with grill and seating'
  },
  {
    id: 29,
    src: '//openapi.images.anywhere.re/3ADEF0C9-03D8-4861-B9DB-8A7DA6427B5E',
    thumbnail: '//openapi.images.anywhere.re/3ADEF0C9-03D8-4861-B9DB-8A7DA6427B5E',
    alt: 'Spa bathroom',
    caption: 'Luxury spa bathroom with soaking tub'
  },
  {
    id: 30,
    src: '//openapi.images.anywhere.re/45131978-0BDD-4735-AD0D-A80206D7D50A',
    thumbnail: '//openapi.images.anywhere.re/45131978-0BDD-4735-AD0D-A80206D7D50A',
    alt: 'Wine tasting room',
    caption: 'Dedicated wine tasting and storage area'
  },
  {
    id: 31,
    src: '//openapi.images.anywhere.re/670FE02E-C82A-4B0C-AE2A-3B2CDD74DC85',
    thumbnail: '//openapi.images.anywhere.re/670FE02E-C82A-4B0C-AE2A-3B2CDD74DC85',
    alt: 'Art studio',
    caption: 'Creative art studio with natural lighting'
  },
  {
    id: 32,
    src: '//openapi.images.anywhere.re/9799C512-3035-40FD-8CCA-2B62D09216A5',
    thumbnail: '//openapi.images.anywhere.re/9799C512-3035-40FD-8CCA-2B62D09216A5',
    alt: 'Music room',
    caption: 'Dedicated music room with acoustic design'
  },
  {
    id: 33,
    src: '//openapi.images.anywhere.re/8D57821C-97FC-4089-8734-F51FEFE24CA4',
    thumbnail: '//openapi.images.anywhere.re/8D57821C-97FC-4089-8734-F51FEFE24CA4',
    alt: 'Greenhouse',
    caption: 'Attached greenhouse for year-round gardening'
  },
  {
    id: 34,
    src: '//openapi.images.anywhere.re/225AD286-53BE-4B6A-9766-A096958BA735',
    thumbnail: '//openapi.images.anywhere.re/225AD286-53BE-4B6A-9766-A096958BA735',
    alt: 'Home bar',
    caption: 'Elegant home bar with custom cabinetry'
  },
  {
    id: 35,
    src: '//openapi.images.anywhere.re/9AF1F10D-F819-4657-A0CC-17E57042B73D',
    thumbnail: '//openapi.images.anywhere.re/9AF1F10D-F819-4657-A0CC-17E57042B73D',
    alt: 'Screening room',
    caption: 'Professional screening room with theater seating'
  },
  {
    id: 36,
    src: '//openapi.images.anywhere.re/383E4561-B801-4C57-8E86-3991BF7E3B55',
    thumbnail: '//openapi.images.anywhere.re/383E4561-B801-4C57-8E86-3991BF7E3B55',
    alt: 'Billiards room',
    caption: 'Classic billiards room with custom table'
  },
  {
    id: 37,
    src: '//openapi.images.anywhere.re/39A4132F-ADC9-4F16-9F09-2252F0265AEB',
    thumbnail: '//openapi.images.anywhere.re/39A4132F-ADC9-4F16-9F09-2252F0265AEB',
    alt: 'Conservatory',
    caption: 'Beautiful conservatory with glass ceiling'
  },
  {
    id: 38,
    src: '//openapi.images.anywhere.re/25B4C4CC-8E0E-4512-BCB9-59DF949DCF98',
    thumbnail: '//openapi.images.anywhere.re/25B4C4CC-8E0E-4512-BCB9-59DF949DCF98',
    alt: 'Home spa',
    caption: 'Luxury home spa with massage room'
  },
  {
    id: 39,
    src: '//openapi.images.anywhere.re/3D176A74-AACA-4DAF-B98E-20409DA768CE',
    thumbnail: '//openapi.images.anywhere.re/3D176A74-AACA-4DAF-B98E-20409DA768CE',
    alt: 'Tennis court',
    caption: 'Private tennis court with lighting'
  },
  {
    id: 40,
    src: '//openapi.images.anywhere.re/4EE4E4BE-2DBB-4498-844C-327EE5A8E922',
    thumbnail: '//openapi.images.anywhere.re/4EE4E4BE-2DBB-4498-844C-327EE5A8E922',
    alt: 'Boat dock',
    caption: 'Private boat dock with water access'
  },
  {
    id: 41,
    src: '//openapi.images.anywhere.re/68EA2F46-4A5C-4F6F-9A11-54DDBAE433F6',
    thumbnail: '//openapi.images.anywhere.re/68EA2F46-4A5C-4F6F-9A11-54DDBAE433F6',
    alt: 'Helipad',
    caption: 'Private helipad for convenient access'
  },
  {
    id: 42,
    src: '//openapi.images.anywhere.re/BEED4231-EA78-4409-AB90-9A7CB510B249',
    thumbnail: '//openapi.images.anywhere.re/BEED4231-EA78-4409-AB90-9A7CB510B249',
    alt: 'Guest house',
    caption: 'Separate guest house with full amenities'
  },
  {
    id: 43,
    src: '//openapi.images.anywhere.re/541EFC47-158B-4A68-AF91-516B5C1AC2BA',
    thumbnail: '//openapi.images.anywhere.re/541EFC47-158B-4A68-AF91-516B5C1AC2BA',
    alt: 'Staff quarters',
    caption: 'Comfortable staff quarters with kitchen'
  },
  {
    id: 44,
    src: '//openapi.images.anywhere.re/D5D8D256-61D5-4622-8D66-9A7412E2FA10',
    thumbnail: '//openapi.images.anywhere.re/D5D8D256-61D5-4622-8D66-9A7412E2FA10',
    alt: 'Security room',
    caption: 'Advanced security monitoring center'
  },
  {
    id: 45,
    src: '//openapi.images.anywhere.re/324DCEE1-B201-4005-813A-88F6C5863532',
    thumbnail: '//openapi.images.anywhere.re/324DCEE1-B201-4005-813A-88F6C5863532',
    alt: 'Wine cellar entrance',
    caption: 'Elegant entrance to temperature-controlled wine cellar'
  },
  {
    id: 46,
    src: '//openapi.images.anywhere.re/E852FDB9-6D1B-4AA6-AA2B-5B09AAD7F24A',
    thumbnail: '//openapi.images.anywhere.re/E852FDB9-6D1B-4AA6-AA2B-5B09AAD7F24A',
    alt: 'Panoramic view',
    caption: 'Spectacular panoramic views from the property'
  },
  {
    id: 47,
    src: '//openapi.images.anywhere.re/DA56817B-0DF3-4CF6-B4F3-E41E9A08F1FE',
    thumbnail: '//openapi.images.anywhere.re/DA56817B-0DF3-4CF6-B4F3-E41E9A08F1FE',
    alt: 'Sunset view',
    caption: 'Breathtaking sunset views from the terrace'
  },
  {
    id: 48,
    src: '//openapi.images.anywhere.re/CEB85263-A3BB-4E2A-9BED-ADEDE746C999',
    thumbnail: '//openapi.images.anywhere.re/CEB85263-A3BB-4E2A-9BED-ADEDE746C999',
    alt: 'Garden view',
    caption: 'Manicured gardens with water features'
  },
  {
    id: 49,
    src: '//openapi.images.anywhere.re/82016040-3F87-49C2-AC8B-0207FAAEE3B1',
    thumbnail: '//openapi.images.anywhere.re/82016040-3F87-49C2-AC8B-0207FAAEE3B1',
    alt: 'Driveway entrance',
    caption: 'Grand entrance with circular driveway'
  },
  {
    id: 50,
    src: '//openapi.images.anywhere.re/31597785-54E9-43D7-A6C8-4C445EE2C691',
    thumbnail: '//openapi.images.anywhere.re/31597785-54E9-43D7-A6C8-4C445EE2C691',
    alt: 'Aerial view',
    caption: 'Stunning aerial view of the entire property'
  }
];

const shortImageList = sampleImages.slice(0, 5);

// Extended list with more real estate images
const longImageList: SliderImage[] = sampleImages;

export default {
  title: 'Components/SliderGallery',
  component: SliderGallery,
  parameters: {
    layout: 'padded',
    docs: {
      description: {
        component: 'A slider gallery component with thumbnails at the bottom, navigation controls, and fullscreen support. Built without third-party dependencies.'
      }
    }
  },
  argTypes: {
    images: {
      description: 'Array of image objects',
      control: false
    },
    autoPlay: {
      description: 'Enable auto-play slideshow',
      control: 'boolean'
    },
    autoPlayInterval: {
      description: 'Interval between auto-play transitions (ms)',
      control: { type: 'range', min: 1000, max: 10000, step: 500 }
    },
    showNav: {
      description: 'Show navigation arrows',
      control: 'boolean'
    },
    showThumbnails: {
      description: 'Show thumbnail strip at bottom',
      control: 'boolean'
    },
    showCaptions: {
      description: 'Show image captions',
      control: 'boolean'
    },
    showFullscreen: {
      description: 'Show fullscreen button',
      control: 'boolean'
    },

    height: {
      description: 'Gallery height in pixels',
      control: { type: 'range', min: 200, max: 800, step: 50 }
    },
    onImageChange: {
      description: 'Callback when image changes',
      action: 'image-changed'
    },
    optimizeImages: {
      description: 'Enable image optimization with imgix parameters',
      control: 'boolean'
    },
    imgixDomain: {
      description: 'Imgix domain for image optimization',
      control: 'text'
    }
  }
};

// Default story
export const SliderDefault = {
  args: {
    images: sampleImages,
    autoPlay: false,
    autoPlayInterval: 3000,
    showNav: true,
    showThumbnails: true,
    showCaptions: false,
    showFullscreen: true,
    height: 800
  }
};

// Auto-play story
export const SliderAutoPlay = {
  args: {
    ...SliderDefault.args,
    autoPlay: true,
    autoPlayInterval: 3000
  }
};

export const SliderFastAutoPlay = {
  args: {
    ...SliderDefault.args,
    autoPlay: true,
    autoPlayInterval: 1500
  }
};

// Navigation variations
export const SliderNoNavigation = {
  args: {
    ...SliderDefault.args,
    showNav: false
  }
};

export const SliderNoThumbnails = {
  args: {
    ...SliderDefault.args,
    showThumbnails: false
  }
};

export const SliderNoCaptions = {
  args: {
    ...SliderDefault.args,
    showCaptions: false
  }
};

export const SliderNoFullscreen = {
  args: {
    ...SliderDefault.args,
    showFullscreen: false
  }
};

// Size variations
export const SliderSmall = {
  args: {
    ...SliderDefault.args,
    height: 300
  }
};

export const SliderLarge = {
  args: {
    ...SliderDefault.args,
    height: 700
  }
};

export const SliderWide = {
  args: {
    ...SliderDefault.args,
    height: 400
  }
};

export const SliderTall = {
  args: {
    ...SliderDefault.args,
    height: 800
  }
};

// Content variations
export const SliderFewImages = {
  args: {
    ...SliderDefault.args,
    images: shortImageList
  }
};

export const SliderManyImages = {
  args: {
    ...SliderDefault.args,
    images: longImageList
  }
};

// Edge cases
export const SliderEmptyGallery = {
  args: {
    ...SliderDefault.args,
    images: []
  }
};

export const SliderSingleImage = {
  args: {
    ...SliderDefault.args,
    images: [sampleImages[0]]
  }
};

// Images without captions
export const SliderImagesWithoutCaptions = {
  args: {
    ...SliderDefault.args,
    images: sampleImages.map(img => ({
      ...img,
      caption: undefined
    }))
  }
};

// Minimal configuration
export const SliderMinimal = {
  args: {
    images: sampleImages,
    showNav: false,
    showThumbnails: false,
    showCaptions: false,
    showFullscreen: false,
    height: 400
  }
};

// Full featured
export const SliderFullFeatured = {
  args: {
    images: longImageList,
    autoPlay: true,
    autoPlayInterval: 4000,
    showNav: true,
    showThumbnails: true,
    showCaptions: false,
    showFullscreen: true,
    height: 800
  }
};

// Custom styling
export const SliderCustomStyling = {
  args: {
    ...SliderDefault.args,
    className: 'custom-slider-gallery',
    style: {
      border: '3px solid #007bff',
      borderRadius: '16px'
    }
  }
};

// Interactive story with controls
export const SliderPlayground = {
  args: {
    ...SliderDefault.args
  }
};

// Image optimization story
export const SliderWithImageOptimization = {
  args: {
    ...SliderDefault.args,
    optimizeImages: true,
    imgixDomain: 'openapi.images.anywhere.re'
  }
};

// Example with different imgix domain
export const SliderWithCustomImgixDomain = {
  args: {
    ...SliderDefault.args,
    optimizeImages: true,
    imgixDomain: 'assets.imgix.net'
  }
};



// Direct URLs without any optimization
export const SliderDirectUrls = {
  args: {
    ...SliderDefault.args,
    optimizeImages: false
  }
}; 